import { jsx as _jsx } from "react/jsx-runtime";
import { SidePanelClosed, SidePanelOpen } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useCallback } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { usePDFOutlineContext } from "~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext";
export const PDFOutlineToggleButton = /*#__PURE__*/ memo(()=>{
    const { setActiveLeftContentPanel, setShowContentLeftPanel } = useAssetModalPanel();
    const { isOutlineOpen, setIsOutlineOpen } = usePDFOutlineContext();
    const toggleOutline = useCallback(()=>{
        const newOutlineState = !isOutlineOpen;
        setIsOutlineOpen(newOutlineState);
        setShowContentLeftPanel((prev)=>{
            const willOpen = !prev;
            if (willOpen) {
                setActiveLeftContentPanel("pdfOutline");
            }
            return willOpen;
        });
    }, [
        isOutlineOpen,
        setIsOutlineOpen,
        setActiveLeftContentPanel,
        setShowContentLeftPanel
    ]);
    return /*#__PURE__*/ _jsx(IconButton, {
        icon: isOutlineOpen ? SidePanelOpen : SidePanelClosed,
        label: isOutlineOpen ? "Close PDF Outline" : "Open PDF Outline",
        appearance: "ghost",
        color: "grey",
        onClick: toggleOutline,
        "data-testid": "PDF_OUTLINE_TOGGLE_BUTTON"
    });
});
PDFOutlineToggleButton.displayName = "PDFOutlineToggleButton";
